import gql from 'graphql-tag';



export const add = gql`mutation CreateCommodityGroup($commodityGroup: CommodityGroupInput!) {
    createCommodityGroup(commodityGroup: $commodityGroup) {
        id
        name
    }
}`;

export const edit = gql`mutation EditCommodityGroup($id: ID!, $commodityGroup: CommodityGroupInput!) {
    editCommodityGroup(id: $id, commodityGroup: $commodityGroup) {
        id
        name
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/mutations/commodityGroup.js